import { EvtHeader } from "components/header";
import React from "react";
import CostMasterForm from "../form";

const CreateCostMaster = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Cost Master" />
      <div className="p-6 max-w-2xl">
        <CostMasterForm />
      </div>
    </div>
  );
};

export default CreateCostMaster;
